import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        update: '&',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'user.Restore password' | translate }}</h2>
        </div>
        <form ng-submit="vm.save()">
            <div class="modal-body">
                <div class="form">
                    <form-row error="vm.form.errors.email || vm.form.errors.companySlug">
                        <label class="label">{{ 'user.E-mail' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.form.model.email" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </div>
            </div>
            <div class="modal-footer">
                <ul class="actions01">
                    <li class="primary"><button class="btn main" type="submit" >{{ 'user.Reset password' | translate }}</button></li>
                    <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'user.Cancel' | translate }}</button></li>
                </ul>
            </div>
        </form>
    `
})
export default class {
    constructor ($rootScope, $stateParams, FormFactory, UserResource) {
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.FormFactory = FormFactory;
        this.UserResource = UserResource;
        this.buttonIsPressed = false; // variable for not allowing press multiple time
    }

    $onInit () {
        const defaultModel = {
            email: '',
            companySlug: this.$stateParams.company
        };
        this.form = this.FormFactory.create(defaultModel, model => this.UserResource.resetPasswordPublic({ _lang: this.$rootScope.company.defaultLanguage.toLowerCase() }, model).$promise);
    }

    save () {
        if (!this.buttonIsPressed || this.form.errors.email || this.form.errors.companySlug) {
            this.buttonIsPressed = true;
            this.form.save().then(() => {
                this.update();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/account/restore/index.js